export default __webpack_public_path__ + "static/media/yellow_checkmark_1.3e4ed335.svg";